/* © 2024-2026 Johannes Roob. Proprietärer Code. Keine Nutzung oder Weitergabe ohne Erlaubnis. | Proprietary code. No use or distribution without permission. */

import { mustClosest, mustMap, mustQuerySelector } from "./must.js";
import { DataGrid } from "../controls/custom/DataGrid.js";

export class DataGridManager {
    #instances: Map<HTMLElement, DataGrid> = new Map();

    create(element: HTMLElement) {
        if (!element.matches("div.DataGrid")) {
            throw new Error("DataGridManager: this is not a DataGrid");
        }

        if (this.#instances.has(element)) {
            const dg = this.#instances.get(element);
            throw new Error("DataGridManager: DataGrid already exists");
        }

        const dg = new DataGrid(element);
        this.#instances.set(element, dg);
        dg.init();
    }

    destroy(element: HTMLElement) {
        if (!element.matches("div.DataGrid")) {
            throw new Error("DataGridManager: this is not a DataGrid");
        }

        const dg = mustMap(this.#instances, element);
        dg.destroy();
        this.#instances.delete(element);
    }

    has(any: HTMLElement): boolean {
        return this.#instances.has(mustElement(any));
    }

    get(any: HTMLElement): DataGrid {
        return mustMap(this.#instances, mustElement(any));
    }

    destoryAll() {
        for (const dg of this.#instances.values()) {
            dg.destroy();
        }

        this.#instances.clear();
    }
}

function mustElement(any: HTMLElement): HTMLElement {
    const form = mustClosest(any, "form");
    const element = mustQuerySelector(form, "div.DataGrid");
    return element;
}